import { render } from "./CbContactForm.vue?vue&type=template&id=de0f4fbe&scoped=true&ts=true"
import script from "./CbContactForm.vue?vue&type=script&lang=ts"
export * from "./CbContactForm.vue?vue&type=script&lang=ts"

import "./CbContactForm.vue?vue&type=style&index=0&id=de0f4fbe&lang=css&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de0f4fbe"]])

export default __exports__